import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton, Icon } from 'src/components/ui'

import styles from './Error.module.scss'

interface ErrorProps {
  variant: 'serverError' | 'connectError' | 'generalError' | 'technicalError'
  type?: string
}

const Error: FC<ErrorProps> = ({ variant, type }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  let content

  switch (variant) {
    case 'serverError':
      content = (
        <div className={styles.error_info}>
          <h1 className={styles.error_title}>{t('error_page.server.title')}</h1>
          <p className={styles.error_description}>{t('error_page.server.description')}</p>
        </div>
      )
      break
    case 'connectError':
      content = (
        <div className={styles.error_info}>
          <h1 className={styles.error_title}>{t('error_page.connect.title')}</h1>
          <p className={styles.error_description}>{t('error_page.connect.description')}</p>
        </div>
      )
      break
    case 'generalError':
      content = (
        <div className={styles.error_info}>
          <h1 className={styles.error_title}>{t(`error_page.general.${type}.title`)}</h1>
          <p className={styles.error_description}>{t(`error_page.general.${type}.description`)}</p>
        </div>
      )
      break
    case 'technicalError':
      content = (
        <div className={styles.error_info}>
          <h1 className={styles.error_title}>{t('error_page.technical.title')}</h1>
          <p className={styles.error_description}>{t('error_page.technical.description')}</p>
        </div>
      )
      break
  }

  return (
    <main className={styles.error}>
      <div className={styles.error_icon}>
        <Icon name={variant} />
      </div>
      <div className={styles.error_content}>
        {content}
        {variant !== 'generalError' ? (
          <CustomButton className={styles.btn} variant='contained' color='white'>
            {t('error_page.update')}
          </CustomButton>
        ) : (
          <div className={styles.tabs}>
            <CustomButton
              onClick={() => {
                navigate('/support')
              }}
              className={styles.tabs_support}
              variant='outlined'
              color='white'
            >
              {t('error_page.support_service')}
            </CustomButton>
            <CustomButton onClick={() => navigate('/')} className={styles.tabs_tab} variant='contained' color='white'>
              {t('error_page.on_main')}
            </CustomButton>
          </div>
        )}
      </div>
    </main>
  )
}

export default Error
